const clearFilters = () => {
  if(jQuery(this).hasClass('search')) {
    window.location.assign($('.logo > a').attr('href'));
    return false;
  }
  jQuery('.tags').not('.date').tagit('removeAll');
  jQuery('.tags.date').eq(0).val('');
  jQuery('.tags.date').eq(1).val('');

  for(var i=0; i<loadedMarkers.length; i++) {
    loadedMarkers[i].setVisible(true);
    jQuery('.item.'+loadedMarkers[i].internalClass).show();
  }
  closeSearchFilter()
}

const closeSearchFilter = () => {
  jQuery('.search-filter .body, .search-filter .head').toggleClass('active');
  jQuery('input.search-field').focus();
}

( () => {
  jQuery('.search-filter .erase').on('click', clearFilters)
  jQuery('#submit-apply').on('click', closeSearchFilter)
  jQuery('.search-filter .head').on('click', closeSearchFilter)	
})()